/**
 * Customer-facing display config for BALDER usage packs (dashboard-only, dependency
 * light). Mirrors the authoritative pack catalogue in `packages/billing/src/usage-packs.ts`
 * — code, size and VAT-inclusive price only. Never exposes cost or margin figures.
 */

export interface PackDisplay {
  readonly code: string;
  readonly name: string;
  /** Extra BALDER build requests this pack adds to the current billing period. */
  readonly builds: number;
  /** VAT-inclusive price, formatted for display. */
  readonly price: string;
}

export const PACK_VAT_NOTE = "All prices include VAT. Packs add builds to your current billing period.";

export const USAGE_PACKS: readonly PackDisplay[] = [
  { code: "PACK_50", name: "50 extra builds", builds: 50, price: "€15" },
  { code: "PACK_200", name: "200 extra builds", builds: 200, price: "€50" },
  { code: "PACK_500", name: "500 extra builds", builds: 500, price: "€120" },
];
